import React from 'react';
import { compose, graphql } from 'react-apollo';

import ReceivedEmail from '../../../../ReceivedEmail';
import { EmailMessage } from '../../../../../queries/EmailMessageSimplified';

const EmailAction = ({ data, details }) =>
  data && data.emailMessage ? (
    <ReceivedEmail
      email={data.emailMessage}
      icon="user"
      toggleImportLabel={true}
    />
  ) : (
    details
  );

export default compose(
  graphql(EmailMessage, {
    options: ({ emailId }) => ({
      variables: {
        id: emailId
      }
    })
  })
)(EmailAction);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ActionTypes/EmailAction.js